import ProjectService from '../../../services/projects.service'
import BotsService from '../../../services/bots.service'
import { Notification } from 'element-ui';
export default {
  loadBot({ state, commit }, payload) {
    commit('SET_LOADING', true)
    return BotsService.getBotWithProject(payload.params, commit)
    .then(response => {
      commit('SET_PROJECT', response[0])
      commit('SET_BOT', response[1])
      commit('SET_LOADING', false)
    })
    .catch(error => commit('SET_ERROR', error.message))
    .finally(() => commit('SET_LOADING', false))
  },

  updateBot({ state, commit }, payload) {
    commit('SET_LOADING', true)
    return BotsService.updateBot(payload.model, commit)
    .then(response => {
      Notification.success({
        title: `Bot has been updated`,
        message: ''
      });
      commit('SET_LOADING', false)
      commit('BOT_UPDATED', response);
    })
    .catch(error => {
      Notification.error({
        title: 'Bot hasn\'t been updated',
        message: error.message,
        duration: 0
      });
    })
    .finally(() => commit('SET_LOADING', false))
  },

  setAdvanced({ state, commit }, payload) {
    commit('SET_LOADING', true);
    return BotsService.setBotAdvanced(payload, commit)
    .then(response => {
      Notification.success({
        title: `Bot settings have been updated`,
        message: ''
      });
      commit('SET_LOADING', false)
      commit('BOT_UPDATED', {response: response, bot_id: payload.bot_id});
    })
    .catch(error => {
      Notification.error({
        title: 'Bot haven\'t been updated',
        message: error.message,
        duration: 0
      });
    })
    .finally(() => commit('SET_LOADING', false))
  },

  copyBot({ state, commit }, payload) {
    commit('SET_LOADING', true)
    return BotsService.copyBot(payload.model, commit)
    .then(response => {
      Notification.success({
        title: `Bot has been copied`,
        message: ''
      });
      commit('SET_LOADING', false)
      commit('BOT_COPIED', response);
    })
    .catch(error => {
      Notification.error({
        title: 'Bot hasn\'t been copied',
        message: error.message,
        duration: 0
      });
    })
    .finally(() => commit('SET_LOADING', false))
  },

  sortScenario({ state, commit }, payload) {
    commit('SORT_SCENARIO', payload);
  },

  scheduleBotNow({ state, commit }, payload) {
    commit('SET_LOADING', true);  
    return ProjectService.runBot(payload)
    .then(response => {
      Notification.success({
        title: `Bot has been scheduled to be ran ASAP`,
        message: ''
      });
        
      commit('BOT_RAN_NOW', response.data);
    })
    .catch(error => {
      Notification.error({
        title: 'Bot hasn\'t been run',
        message: error.message,
        duration: 0
      });
    })
    .finally(() => {
      setTimeout(function() {
        commit('SET_LOADING', false);
      }, 1000)
      
    })
  },


 
}
